/**************************************************
 * Nombre:       Formulario_Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, Grid, LinearProgress, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import Tarjetas_Producto from "../Tarjetas/Tarjetas_Producto";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {obtenerTotalProductos} from "../Utilidades/obtenerTotalProductos";
import {theme} from "../../Tema";
import {sacarPorcentaje} from "../Utilidades/sacarPorcentaje";
import {VALORENVIOGRATIS} from "../../Constantes";

const Formulario_Lista_Productos = ({...props}) => {
    const [productos, setProductos] = useState([])



    useEffect(() => {


        setProductos(props.props.getValues('productos'))

    }, [props.props.watch('productos')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {productos.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjetas_Producto item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        // sx={{backgroundColor: 'pink'}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}
                              sx={{mt: 1, pr: 2}}>
                            <Typography sx={{
                                fontSize: 18,
                                fontWeight: 700,
                                color: theme.palette.primary.main
                            }}>{`Valor Compra : ${formatoMoneda(obtenerTotalProductos(productos))}`}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -1}}>
                            <Box sx={{width: '100%', mr: 1}}>
                                <LinearProgress variant="determinate" value={sacarPorcentaje({
                                    valor: obtenerTotalProductos(productos),
                                    maximo: VALORENVIOGRATIS
                                })}/>
                            </Box>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -2}}>

                            {sacarPorcentaje({
                                valor: obtenerTotalProductos(productos),
                                maximo: VALORENVIOGRATIS
                            }) >= 100 ?
                                <Typography
                                    sx={{fontSize: 18, color: theme.palette.primary.main, fontWeight: 600}}>Envio
                                    Gratis!!</Typography>
                                :
                                <Typography
                                    sx={{fontSize: 12}}>{`Falta ${formatoMoneda(VALORENVIOGRATIS - obtenerTotalProductos(productos))} para envío gratis`}</Typography>
                            }

                        </Grid>


                    </Grid>

                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lista_Productos